export const APP_STORE_URLS = {
  ios: "https://apps.apple.com/app/id6762061214",
  android:
    "https://play.google.com/store/apps/details?id=io.audioscribe.android",
};

/**
 * "ios" | "android" | null for the current device. iPadOS 13+ reports a
 * Mac UA; the maxTouchPoints check catches it.
 */
export function getMobilePlatform(
  ua = navigator.userAgent,
  maxTouchPoints = navigator.maxTouchPoints || 0,
) {
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Macintosh/i.test(ua) && maxTouchPoints > 1) return "ios";
  if (/Android/i.test(ua)) return "android";
  return null;
}

export function getStoreUrl(platform) {
  return APP_STORE_URLS[platform] || null;
}
